import { BrandContextDocument, BrandContextDocumentExtractionStatus, BrandLearning } from "@/types/brand-context";

export type BrandContextEntry =
  | { type: "learning"; id: string; title: string; category: string; tags: string[]; authorName: string; createdAt: string; body: string }
  | {
      type: "document";
      id: string;
      title: string;
      category: string;
      tags: string[];
      authorName: string;
      createdAt: string;
      fileName: string;
      fileSize: number;
      mimeType: string;
      extractionStatus: BrandContextDocumentExtractionStatus;
    };

export function toEntries(learnings: BrandLearning[], documents: BrandContextDocument[]): BrandContextEntry[] {
  const learningEntries: BrandContextEntry[] = learnings.map((l) => ({
    type: "learning",
    id: l.id,
    title: l.title,
    category: l.category,
    tags: l.tags,
    authorName: l.authorName,
    createdAt: l.createdAt,
    body: l.body,
  }));

  const documentEntries: BrandContextEntry[] = documents.map((d) => ({
    type: "document",
    id: d.id,
    title: d.title,
    category: d.category,
    tags: d.tags,
    authorName: d.authorName,
    createdAt: d.createdAt,
    fileName: d.fileName,
    fileSize: d.fileSize,
    mimeType: d.mimeType,
    extractionStatus: d.extractionStatus,
  }));

  return [...learningEntries, ...documentEntries].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );
}

export type EntryTypeFilter = "all" | "learning" | "document";

export function filterEntries(
  entries: BrandContextEntry[],
  search: string,
  typeFilter: EntryTypeFilter,
  categoryFilter: string,
): BrandContextEntry[] {
  const query = search.trim().toLowerCase();

  return entries.filter((entry) => {
    if (typeFilter !== "all" && entry.type !== typeFilter) return false;
    if (categoryFilter !== "all" && entry.category !== categoryFilter) return false;
    if (query === "") return true;

    const haystack = [
      entry.title,
      entry.category,
      ...entry.tags,
      entry.type === "learning" ? entry.body : entry.fileName,
    ]
      .join(" ")
      .toLowerCase();

    return haystack.includes(query);
  });
}
